import type { ComponentProps } from 'solid-js'
import { splitProps } from 'solid-js'

import { FORM_CONTROL_CLASS } from './formControlClass'

/**
 * Renders a themed select; pass `<option>` elements as children.
 *
 * @param props - Standard select props.
 * @returns The select element.
 */
const Select = (props: ComponentProps<'select'>) => {
   const [local, rest] = splitProps(props, ['class'])
   return (
      <select
         {...rest}
         class={[FORM_CONTROL_CLASS, 'app-select pr-10', local.class]
            .filter(Boolean)
            .join(' ')}
      />
   )
}

export default Select
